// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
})();

// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 7);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();

//faq tab
document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".faq-tab-btn");
  const panels = document.querySelectorAll(".faq-panel");

  function openFirstAccordion(panel) {
    if (!panel) return;

    let allDetails = panel.querySelectorAll("details");

    allDetails.forEach(d => d.removeAttribute("open"));

    if (allDetails.length > 0) {
      allDetails[0].setAttribute("open", true);
    }
  }

  let firstActivePanel = document.querySelector(".faq-panel.active");
  openFirstAccordion(firstActivePanel);

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      let targetId = this.dataset.tab;
      let targetPanel = document.getElementById(targetId);

      tabs.forEach(t => t.classList.remove("active"));
      panels.forEach(p => p.classList.remove("active"));

      this.classList.add("active");
      targetPanel.classList.add("active");

      setTimeout(() => {
        openFirstAccordion(targetPanel);
      }, 50);
    });
  });

  document.querySelectorAll(".faq-item details").forEach(detail => {
    detail.addEventListener("toggle", function () {

      if (this.open) {
        let parentPanel = this.closest(".faq-panel");
        let allDetails = parentPanel.querySelectorAll("details");

        allDetails.forEach(d => {
          if (d !== this) {
            d.removeAttribute("open");
          }
        });
      }

    });
  });

});


// =============== PDP tab
const tabTitles = document.querySelectorAll('.tab-title');

if (tabTitles.length > 0) {

  const tabContents = document.querySelectorAll('.tab_content');
  tabTitles.forEach(title => {
    title.addEventListener('click', function () {
      const currentTab = this.getAttribute('data-title');
      // Remove active class
      tabTitles.forEach(item => item.classList.remove('active'));
      tabContents.forEach(item => item.classList.remove('active'));
      // Add active class to clicked tab
      this.classList.add('active');
      // Match content
      const matchedContent = document.querySelector(
        `.tab_content[data-content="${currentTab}"]`
      );
      if (matchedContent) {
        matchedContent.classList.add('active');
      }
    });
  });
}



  (function () {
    const section = document.getElementById("read-more-{{ section.id }}");
    if (!section) return;

    const button = section.querySelector(".read-toggle");

    button.addEventListener("click", function () {
      section.classList.toggle("expanded");

      if (section.classList.contains("expanded")) {
        button.textContent = "{{ section.settings.read_less_label }}";
      } else {
        button.textContent = "{{ section.settings.read_more_label }}";
      }
    });
  })();